import { i18n } from '@shared/i18n';
import IdField from '@shared/fields/id-field';
import DateTimeRangeField from '@shared/fields/date-time-range-field';
import DateTimeField from '@shared/fields/date-time-field';
import { GenericModel } from '@shared/model/generic-model';
import StringField from '@shared/fields/string-field';
import EnumeratorField from '@shared/fields/enumerator-field';
import ImagesField from '@shared/fields/images-field';
import EmailsField from '@shared/fields/emails-field';
import { UserField } from '@modules/auth/user-field';
import IntegerField from '@shared/fields/integer-field';
import JsonField from '@shared/fields/json-field';
import getSharedEnumeratorField from '@shared/fields/helpers/getSharedEnumeratorField';

function label(name) {
  return i18n(`entities.property.fields.${name}`);
}

const fields = {

  id: new IdField('id', label('id')),
  name: new StringField('name', label('name'), {
    "required": true
  }),
  country: new EnumeratorField('country', label('country'), getSharedEnumeratorField('country'), { required: true }),
  
  emails: new EmailsField('emails', label('emails'), {}),

  managers: UserField.relationToMany('managers', label('managers'), {}),

  type: new EnumeratorField('type', label('type'), getSharedEnumeratorField('propertyType'), { required: true }),

  status: new EnumeratorField('status', label('status'), getSharedEnumeratorField('propertyStatus'), { required: true }),

  access: new EnumeratorField('access', label('access'), getSharedEnumeratorField('access'), { required: true }),

  sport: new EnumeratorField('sport', label('sport'), getSharedEnumeratorField('sport'), { required: true }),

  logos: new ImagesField(
    'logos',
    label('logos'),
    (id) => `properties/${id}/logos`,
    { max: 1, "required": true },
  ),
  logosProperty: new ImagesField(
    'logos',
    label('logos'),
    `properties/logos`,
    { max: 1 },
  ),
  maxNumSubproperty: new IntegerField(
    'maxNumSubproperty',
    label('maxNumSubproperty'),
    {required: true}
  ), 

  createdAt: new DateTimeField(
    'createdAt',
    label('createdAt'),
  ),
  updatedAt: new DateTimeField(
    'updatedAt',
    label('updatedAt'),
  ),
  createdAtRange: new DateTimeRangeField(
    'createdAtRange',
    label('createdAtRange'),
  ),
  subproperty: new JsonField('subproperty', label('subproperty'))
};

export class PropertyModel extends GenericModel {
  static get fields() {
    return fields;
  }
}
